export default __webpack_public_path__ + "build/ac590fb89b4df303772349ea32f0c1b1.jpg";